import { GlobalManager } from '@/context'
import { UploadErrorEnum } from '.'
import { useI18n } from '@/i18n'

export const processUploadError = (error?: UploadErrorEnum) => {
  const { t } = useI18n()
  if (error) {
    switch (error) {
      case UploadErrorEnum.FILE_NULL:
        GlobalManager.Modal.message({
          type: 'warning',
          content: t('lobby.common.upload.error.fileNull')
        })
        break
      case UploadErrorEnum.FILE_TYPE_EXCLUDE:
        GlobalManager.Modal.message({
          type: 'warning',
          content: t('lobby.common.upload.error.fileType')
        })
        break
      case UploadErrorEnum.SIZE_EXCEEDS:
        GlobalManager.Modal.message({
          type: 'warning',
          content: t('lobby.common.upload.error.fileSize')
        })
        break
    }
  }
}
